<!-- Modern Header Section -->
<div class="m-4">
  <div class="switch-admin-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="switch-admin-title">
          <i class="pi pi-link mr-3"></i>
          Switch Webhook Administration
        </h1>
        <p class="switch-admin-subtitle">
          Manage webhooks and create custom submission points
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Main Content Area -->
<div class="switch-admin-content">
  <div class="action-cards-grid">
    <!-- View Submit Points Card -->
    <div class="action-card">
      <div class="action-card-header">
        <div class="action-icon view-icon">
          <i class="pi pi-eye"></i>
        </div>
        <h2 class="action-title">View Submit Points</h2>
      </div>
      <div class="action-card-content">
        <p class="action-description">
          View and manage all webhook submit points created by users
        </p>
      </div>
      <div class="action-card-actions">
        <button
          pButton
          pRipple
          type="button"
          label="View Submit Points"
          icon="pi pi-arrow-right"
          class="modern-button primary"
          [routerLink]="['/switch-webhook-admin']"
        ></button>
      </div>
    </div>

    <!-- Create Custom Webhook Card -->
    <div class="action-card">
      <div class="action-card-header">
        <div class="action-icon create-icon">
          <i class="pi pi-plus-circle"></i>
        </div>
        <h2 class="action-title">Create Custom Webhook</h2>
      </div>
      <div class="action-card-content">
        <p class="action-description">
          Create custom webhooks and configure submission points for users
        </p>
      </div>
      <div class="action-card-actions">
        <button
          pButton
          pRipple
          type="button"
          label="Create Webhook"
          icon="pi pi-arrow-right"
          class="modern-button primary"
          [routerLink]="['/switch-webhook']"
        ></button>
      </div>
    </div>
  </div>
</div>
